import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {AdminComponent} from './admin/admin.component';
import {ReportViewComponent} from './bi/reports/report-view/report-view.component';
import {DashboardViewComponent} from './bi/dashboards/dashboard-view/dashboard-view.component';
import {AuthGuard} from './_guards/auth.guard';
import {LicenseListComponent} from './capa/license/license-list/license-list.component';
import {LicenseViewComponent} from './capa/license/license-view/license-view.component';
import {ResultListComponent} from './capa/result/result-list/result-list.component';
import {ResultViewComponent} from './capa/result/result-view/result-view.component';
import {CapaComponent} from './capa/capa.component';
import {CapaAuthGuard} from './_guards/capaAuth.guard';
import {CreateAccountComponent} from './capa/create-account/create-account.component';
import {CapaAdminAuthGuard} from './_guards/capaAdminAuth.guard';
import {PowerBiObjectListComponent} from './bi/power-bi-object-list/power-bi-object-list.component';

const routes: Routes = [
    {
      path: '',
      component: HomeComponent,
      data:
      {
          title: 'CLHUB - Home'
      },
      canActivate: [AuthGuard]
    },
    {
      path: 'admin',
      component: AdminComponent,
      data:
      {
        roles: ['clhub-client-admin'],
        title: 'CLHUB - Administration'
      },
      canActivate: [AuthGuard]
    },
    {
      path: 'bi/report/list',
      component: PowerBiObjectListComponent,
      data:
        {
          title: 'CLHUB - Power BI',
          isReport: true
        },
      canActivate: [AuthGuard]
    },
    {
      path: 'bi/report/view/:id',
      component: ReportViewComponent,
      data:
      {
          title: 'CLHUB - Power BI'
      },
      canActivate: [AuthGuard]
    },
    {
      path: 'bi/dashboard/list',
      component: PowerBiObjectListComponent,
      data:
        {
          title: 'CLHUB - Power BI',
          isReport: false
        },
      canActivate: [AuthGuard]
    },
    {
      path: 'bi/dashboard/view/:id',
      component: DashboardViewComponent,
      data:
        {
          title: 'CLHUB - Power BI'
        },
      canActivate: [AuthGuard]
    },
    {
      path: 'capa/license/list',
      component: LicenseListComponent,
      canActivate: [CapaAdminAuthGuard],
      data:
      {
          title: 'CAPA'
      }
    },
    {
      path: 'capa/license/view/:id',
      component: LicenseViewComponent,
      canActivate: [CapaAdminAuthGuard],
      data:
      {
          title: 'CAPA'
      }
    },
    {
      path: 'capa/result/list/:id',
      component: ResultListComponent,
      canActivate: [CapaAuthGuard],
      data:
      {
          title: 'CAPA'
      }
    },
    {
      path: 'capa/result/view/:id',
      component: ResultViewComponent,
      canActivate: [CapaAuthGuard],
      data:
      {
          title: 'CAPA'
      }
    },
    {
      path: 'capa',
      component: CapaComponent,
      data:
      {
          title: 'CAPA'
      }
    },
    {
      path: 'capa/create-account',
      component: CreateAccountComponent,
      data:
        {
            title: 'CAPA'
        }
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes/*, {enableTracing: true}*/)],
  exports: [RouterModule],
  providers: [CapaAuthGuard]
})
export class AppRoutingModule { }
